<template>
  <div class="body_monban" >
    <el-tabs  style="height: 200px;" v-model="activeName">
    <el-tab-pane label="客户提现" name="guestTixian"><tixian :admin_flag="1" :type="1"></tixian></el-tab-pane>
    <el-tab-pane label="门店提现" name="qiyeTixian"><tixian :admin_flag="1" :type="2"></tixian></el-tab-pane>
    <el-tab-pane label="员工提现" name="yuangongTixian"><tixian :admin_flag="1" :type="3"></tixian></el-tab-pane>
    <!-- <el-tab-pane label="股东明细" name="gudongMingxi"><gudongMingxi :admin_flag="1"></gudongMingxi></el-tab-pane> -->
    <el-tab-pane label="客户退款" name="tuikuan"><tuikuan :admin_flag="1"></tuikuan></el-tab-pane>
  </el-tabs>

  </div>
</template>
<style>
.body_moban{
  padding-top: 100px;
}
</style>
<script>
// import guestTixian from './guest_tixian.vue';
// import qiyeTixian from './qiye_tixian.vue';
// import yuangongTixian from './yuangong_tixian.vue';
import tixian from '../../tongyong/tixian.vue';
// import gudongMingxi from '../../tongyong/gudong_mingxi.vue';
import tuikuan from '../../tongyong/tuikuan.vue';
export default {
  components: {
    tixian: tixian,
    // gudongMingxi: gudongMingxi,
    tuikuan: tuikuan
 
  },

  data() {
    return {
      // 获取用户列表参数
      activeName: 'guestTixian'
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
